import type { DrawerProps } from "antd";
import { Drawer, Flex } from "antd";
import type { ReactNode } from "react";
import CopyUrlButton from "../copy-url-button";
import { type DrawerSize, resolveDrawerSize } from "./drawerSize";

export interface EnterpriseDrawerProps extends Omit<DrawerProps, "extra" | "title" | "size"> {
  title: ReactNode;
  size?: DrawerSize;
  actions?: ReactNode;
  copyUrl?: string;
  copyUrlTooltip?: ReactNode;
  copyUrlSuccessMessage?: string;
  copyUrlErrorMessage?: string;
}

const EnterpriseDrawer = ({
  title,
  actions,
  copyUrl,
  copyUrlTooltip = "Копировать ссылку",
  copyUrlSuccessMessage = "Ссылка скопирована",
  copyUrlErrorMessage = "Не удалось скопировать ссылку",
  size,
  ...drawerProps
}: EnterpriseDrawerProps) => {
  const copyButton = copyUrl ? (
    <CopyUrlButton
      url={copyUrl}
      tooltip={copyUrlTooltip}
      successMessage={copyUrlSuccessMessage}
      errorMessage={copyUrlErrorMessage}
    />
  ) : null;

  const headerActions =
    copyButton || actions ? (
      <Flex align="center" gap={8}>
        {copyButton}
        {actions}
      </Flex>
    ) : undefined;

  return (
    <Drawer title={title} extra={headerActions} size={resolveDrawerSize(size)} {...drawerProps} />
  );
};

export default EnterpriseDrawer;
